import fetchAuth from "./fetchAuth";
import runtimeEnv from "@mars/heroku-js-runtime-env";

const env = runtimeEnv();

export default async function fetchAPI({
  download,
  archiveName,
  params = {},
  codeCountry,
  service,
  protocol = "POST",
  callbackThen,
  callbackError,
  verifyAuth = true,
  header,
}) {
  const urlService = env.REACT_APP_SERVICES_URL + service;
  const clientId = localStorage.getItem("clientId");
  const originalCodeContry = localStorage.getItem("originalCodeContry");

  let countrysCode = codeCountry;
  if (!codeCountry) {
    countrysCode = params.country
      ? params.country === "México"
        ? "mdmexico"
        : "mdcolombia"
      : params.codeCountry;
  }

  if (!verifyAuth) {
    const options = {
      method: protocol,
      headers: header
        ? header
        : {
            "Content-Type": "application/json",
          },
    };
    options.headers.codecountry = originalCodeContry;

    if (protocol === "POST" || protocol === "PATCH") {
      options.body = JSON.stringify(params);
    }

    return fetch(urlService, options)
      .then((response) => {
        if (response.ok) {
          // if(protocol === "POST" && service === "v1/users"){
          //   fetchAuth({clientId})
          //   .then((dataResponse) => {
          //     callbackThen(dataResponse.data);
          //   })
          // }else{
          return response.text();
          // }
        } else {
          return response.json();
        }
        // throw new Error('Something went wrong.');
      })
      .then((data) => {
        if (typeof callbackThen !== "undefined") {
          callbackThen(
            data.message || data.includes("Id SKU") ? data : JSON.parse(data)
          );
        }
        return JSON.parse(data);
      })
      .catch((e) => {
        if (typeof callbackError !== "undefined") {
          callbackError(e);
        }
      });
  } else if (download) {
    return fetchAuth({ clientId, countrysCode }).then(async (tokenResponse) => {
      const options = {
        method: protocol,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenResponse.access_token,
          codecountry: originalCodeContry,
        },
      };

      if (protocol === "POST" || protocol === "PATCH") {
        options.body = JSON.stringify(params);
      }

      return fetch(urlService, options)
        .then((resp) => {
          return resp.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          // the filename you want
          a.download = `${archiveName}`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          callbackThen(true);
        })
        .catch((e) => {
          if (typeof callbackError !== "undefined") {
            callbackError(e);
          }
        });
    });
  } else {
    return fetchAuth({ clientId, countrysCode }).then(async (tokenResponse) => {
      // console.log({"token Response" : tokenResponse, "clienteID":clientId})
      // if (!tokenResponse)
      //   console.log(
      //     "🚀 ~ file: fetchAPI.js ~ line 35 ~ fetchAPI ~ params",
      //     service,
      //     params,
      //     countrysCode
      //   );
      const options = {
        method: protocol,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenResponse.access_token,
          codecountry: originalCodeContry,
        },
      };

      if (protocol === "POST" || protocol === "PATCH" || protocol === "PUT") {
        options.body = JSON.stringify(params);
      }

      return fetch(urlService, options)
        .then((response) => {
          if (response.ok) {
            // if(protocol === "POST" && service === "v1/users"){
            //   fetchAuth({clientId})
            //   .then((dataResponse) => {
            //     callbackThen(dataResponse.data);
            //   })
            // }else{
            return response.text();
            // }
          } else {
            return response.json();
          }
          // throw new Error('Something went wrong.');
        })
        .then((data) => {
          if (typeof callbackThen !== "undefined") {
            callbackThen(
              data.message || data.includes("Id SKU") ? data : JSON.parse(data)
            );
          }
          return JSON.parse(data);
        })
        .catch((e) => {
          if (typeof callbackError !== "undefined") {
            callbackError(e);
          }
        });
    });
  }
}
